import React, { useState } from "react";
import logo from "../../assets/logo.png";
import "./Navbar.css";

const Navbar = ({ onEnquire }) => {
  const [activeItem, setActiveItem] = useState("Home");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    "Home",
    "About",
    "Price",
    "Floor Plan",
    "Amenities",
    "Master Plan",
    "Location Map",
  ];

  const handleMenuClick = (item) => {
    setActiveItem(item);
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="navbar-container">
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">
          <div className="logo-section">
            <div className="logo">
              <a href="/">
                <img src={logo} alt="logo" />
              </a>
            </div>
          </div>

          <div className="contact-section">
            <div className="promoter-info">
              <span className="promoter-text">GUPTA PROMOTERS</span>
            </div>
            <div className="contact-info">
              <span className="phone-text">Call Now : </span>
              <a href="tel:+919999063322" className="phone-number">
                +91 9999063322
              </a>
              <button className="enquire-btn" onClick={onEnquire} >ENQUIRE NOW</button>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="navigation">
        <div className="container">
          <div className="nav-menu">
            <ul className={`nav-list ${isMobileMenuOpen ? "mobile-open" : ""}`}>
              {navItems.map((item) => (
                <li
                  key={item}
                  className={`nav-item ${activeItem === item ? "active" : ""}`}
                  onClick={() => handleMenuClick(item)}
                >
                  <a
                    href={`#${item.toLowerCase().replace(" ", "-")}`}
                    className="nav-link"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>

            {/* Mobile Menu Toggle */}
            <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
              <span className={`hamburger ${isMobileMenuOpen ? "active" : ""}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
